import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ApiService } from '../../services/api.service';
import { FinalResultService } from '../../services/final-result.service';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { TeamsService } from '../../services/teams.service';

@Component({
  selector: 'app-final-result',
  templateUrl: './final-result.component.html',
  styleUrls: ['./final-result.component.scss'],
  standalone: false,
})
export class FinalResultComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  sidenav: MatSidenav;
  finalResult: any;
  teams: any[];

  pichichiTeamId: string | null = null;
  pichichiPlayers: any[] = [];
  pichichiPlayersLoading: boolean = false;

  constructor(
    private sidenavService: SidenavService,
    private snackbar: SnackbarService,
    private teamsService: TeamsService,
    private finalResultService: FinalResultService,
    private apiService: ApiService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  async ngOnInit() {
    this.teams = await this.teamsService.getList();
    this.finalResult = await this.finalResultService.get();

    // Pre-load players if pichichi is already set
    if (this.finalResult?.pichichi) {
      try {
        const player: any = await this.apiService.request(
          `/players/${this.finalResult.pichichi}`,
          'GET',
        );
        const teamId =
          player?.team?._id ?? player?.team ?? player?.teamId ?? null;
        if (teamId) {
          this.pichichiTeamId = teamId;
          this.pichichiPlayers = await this.apiService.request(
            `/teams/${teamId}/players`,
            'GET',
          );
        }
      } catch {
        // player not found — leave selectors empty
      }
    }
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  getTeamFlag(): string | null {
    if (!this.finalResult?.teamId || !this.teams) return null;
    return (
      this.teams.find((t) => t._id === this.finalResult.teamId)?.flag ?? null
    );
  }

  getPichichiTeamFlag(): string | null {
    if (!this.pichichiTeamId || !this.teams) return null;
    return this.teams.find((t) => t._id === this.pichichiTeamId)?.flag ?? null;
  }

  async onPichichiTeamChange(teamId: string) {
    this.pichichiTeamId = teamId;
    this.finalResult.pichichi = null;
    this.pichichiPlayersLoading = true;
    try {
      this.pichichiPlayers = teamId
        ? await this.apiService.request(`/teams/${teamId}/players`, 'GET')
        : [];
    } catch {
      this.pichichiPlayers = [];
    } finally {
      this.pichichiPlayersLoading = false;
    }
  }

  update() {
    this.blockUI.start();
    this.finalResultService
      .update(this.finalResult)
      .then(() => {
        this.blockUI.stop();
        this.snackbar.success('Los datos se han actualizado correctamente.');
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }
}
